import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import { Banner, DiscountBanner } from 'src/shared/components';
import { useMediaQuery } from 'src/shared/hooks';
import useMobileMenu from 'src/shared/store/useMobileMenu';
import useSidebar from 'src/shared/store/useSidebar';

import ImpersonationBanner from 'src/shared/components/ImpersonationBanner';
import {
  PrivateContent,
  PrivateContentMobile,
  PrivateMobileHeader,
  PrivateSidebar
} from 'src/shared/components/PrivateLayout';
import { Drawer, DrawerContent } from 'src/shared/components/ui';

const PrivateLayout = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const isOpen = useSidebar((state) => state.isOpen);
  const isMobileMenuOpen = useMobileMenu((state) => state.isOpen);
  const closeMobileMenu = useMobileMenu((state) => state.close);
  const impersonation = useAuthStore((state) => state.impersonation);
  const isMobile = useMediaQuery();
  const location = useLocation();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    if (isMobile) {
      closeMobileMenu();
    }
  }, [location.pathname, isMobile, closeMobileMenu]);

  if (!isHydrated) {
    // Prevent flicker
    return null;
  }

  if (isMobile) {
    // overflow-x-clip rather than hidden/auto: those turn the element into a
    // scroll container, and the sticky header would stick to it instead of the
    // viewport.
    return (
      <div className="min-h-dvh flex flex-col overflow-x-clip">
        <div className="sticky top-0 z-50">
          <PrivateMobileHeader />
          {impersonation && <ImpersonationBanner />}
          <Banner />
        </div>

        <div className="flex flex-grow overflow-x-auto">
          <PrivateContentMobile>
            <DiscountBanner localOrGlobal="global" />
            <Outlet />
          </PrivateContentMobile>
        </div>

        <Drawer
          hideCloseButton
          isOpen={isMobileMenuOpen}
          placement="left"
          size="full"
        >
          <DrawerContent>
            <PrivateSidebar isOpen isMobile={isMobile} />
          </DrawerContent>
        </Drawer>
      </div>
    );
  }

  return (
    <div className="min-h-dvh h-dvh flex flex-col">
      <div className="flex flex-grow">
        <PrivateSidebar isOpen={isOpen} />
        <PrivateContent isOpen={isOpen}>
          <div className="sticky top-0 z-20">
            {impersonation && <ImpersonationBanner />}
            <Banner />
          </div>
          <DiscountBanner localOrGlobal="global" />
          <Outlet />
        </PrivateContent>
      </div>
    </div>
  );
};

export default PrivateLayout;
